import { TOO_MANY_DATA_SERIES_THRESHOLD, TOO_MANY_DATA_POINTS_THRESHOLD } from '../constants.js';
import { isDataGroupArray } from './isDataGroup.js';
import { isDataSeriesArray } from './isDataSeries.js';

const hasTooManyDataPoints = (seriesArray, threshold) => {
  return seriesArray.some(series => {
    return series.data.length > threshold;
  });
};

function isLargeDataSet(data, chartType) {
  let isLargeDataSet = false;

  if (chartType == null) {
    return false;
  }

  const thresholdForChart = TOO_MANY_DATA_POINTS_THRESHOLD[chartType];

  if (thresholdForChart == null) {
    return false;
  }

  if (isDataSeriesArray(data)) {
    isLargeDataSet = hasTooManyDataPoints(data, thresholdForChart);
  }

  if (isDataGroupArray(data)) {
    isLargeDataSet = data.some(dataGroup => {
      return hasTooManyDataPoints(dataGroup.series, thresholdForChart);
    });
  }

  const hasManySeries = data.length > TOO_MANY_DATA_SERIES_THRESHOLD;
  return isLargeDataSet || hasManySeries;
}

export { isLargeDataSet };
